import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShareMediaComponent } from './components/share-media/share-media.component';

const routes: Routes = [
	{
		path: ':id',
		component: ShareMediaComponent
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)]
})
export class ShareMediaRouting {}
